module.exports = __webpack_public_path__ + "img/img_sfz2.1d0c9741.png";